import { createContext } from "react";
export const IndexContext = createContext()